"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileDownload = void 0;
const axios_1 = __importDefault(require("axios"));
const dom_util_1 = __importDefault(require("./dom-util"));
const fileDownload = (fileURL, fileName = '') => __awaiter(void 0, void 0, void 0, function* () {
    const blob = yield axios_1.default({
        url: fileURL,
        method: 'GET',
        responseType: 'blob'
    });
    const url = window.URL.createObjectURL(blob.data);
    const AnchorEl = dom_util_1.default.createElement('a', {
        display: 'none',
        href: url,
        download: fileName
    });
    document.body.appendChild(AnchorEl);
    AnchorEl.click();
    window.URL.revokeObjectURL(url);
});
exports.fileDownload = fileDownload;
